import { fetchWithAuth } from "./api";

const host =
    window.location.hostname === "localhost"
        ? "http://localhost:8000/api"
        : "/api";

export interface ComplianceClause {
    clause: string;
    title: string;
    date: string;
    notes: string;
    footnote: string;
    raw: string;
    page_number: number;
    record_id: number;
    clause_date: string;
    position: string;
    response: string;
    status: string;
}

export interface ExtractResponse {
    clauses: ComplianceClause[];
    count: number;
}

export async function extractComplianceMatrix(
    file: File
): Promise<ExtractResponse> {
    const formData = new FormData();
    formData.append("contract_pdf", file);

    const response = await fetchWithAuth(`${host}/shcm/extract`, {
        method: "POST",
        body: formData,
    });

    if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err?.payload || `Request failed: ${response.status}`);
    }

    return response.json();
}
